export const PRODUCT_CATEGORIES = [
  { key: "kids", gr: "Παιδικά", en: "Kids" },
  { key: "vitamins", gr: "Βιταμίνες & Συμπληρώματα", en: "Vitamins & Supplements" },
  { key: "accessories", gr: "Accessories", en: "Accessories" },
  { key: "cosmetics", gr: "Καλλυντικά", en: "Cosmetics" },
  { key: "dermocosmetics", gr: "Δερμοκαλλυντικά", en: "Dermocosmetics" },
  { key: "personal_care", gr: "Προσωπική Φροντίδα", en: "Personal Care" },
  { key: "other", gr: "Υπόλοιπα Προϊόντα", en: "Other Products" },
];

export const categoryLabel = (key, lang) => {
  const c = PRODUCT_CATEGORIES.find((x) => x.key === key);
  if (c) return lang === "gr" ? c.gr : c.en;
  return key || (lang === "gr" ? "Υπόλοιπα Προϊόντα" : "Other Products");
};
